module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 77
// module chunks = 1 3 4 5 7 9 11 13 18 21 23 24 25 27 28 29 30